
import React, { FC } from 'react';

import Base, {Props as BaseProps} from '@components/1-atoms/Text';
import styled from '@emotion/native';

const Text = styled(Base)`
  justify-content: center;
  padding: 12px 3px;
  font-weight: bold;
  letter-spacing: -0.015px;
  
  color: #3D3D3D;
  ${props => props.color && `
    color: ${props.color};
  `}
`;


const Title: FC<TitleProps> = ({  children, ...props }) => {
    return (
      <Text {...props}>{children}</Text>
    );
  }
  
  type TitleProps = BaseProps & {
    children: React.ReactNode | Text;
  };
  
  export default Title;